import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'submit-btn',
  template: `
        <button type="button" class="btn btn-next" (click)="onSubmit()">
            <ng-content></ng-content>
      </button>
          `,
  styleUrls: ['./submit-btn.component.css']
})
export class SubmitBtnComponent implements OnInit {
  @Output() onClick: any = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSubmit() {
    this.onClick.emit();
  }
}
